import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{padding: "100px"}}>
            <h1>Oops!</h1>
            <p>Page not found</p>
            <Link to="/">Visit Our Homepage</Link>
        </article>
    )
}

export default Missing;